import { CronJobHealth, CronJobsResponse } from 'types/cronJob'
import { HEALTH_INFO, HEALTH_ORDER } from './utils'

type Props = {
  summary: CronJobsResponse['summary']
  selectedHealth?: string
  onSelect: (health: CronJobHealth | '') => void
}

// One card per health value; clicking a card filters the table by it
const CronJobSummary = ({ summary, selectedHealth, onSelect }: Props) => (
  <div className="mb-3 grid grid-cols-4 gap-2 md:grid-cols-8">
    <button
      type="button"
      onClick={() => onSelect('')}
      className={`rounded-md border bg-white px-2 py-1.5 text-left ${
        !selectedHealth ? 'border-gray-800' : 'border-gray-200'
      }`}
    >
      <p className="truncate text-[11px] text-gray-500">All jobs</p>
      <p className="text-lg font-semibold leading-6 text-gray-800">
        {summary.total ?? 0}
      </p>
    </button>

    {HEALTH_ORDER.map((health) => (
      <button
        key={health}
        type="button"
        onClick={() => onSelect(health)}
        className={`rounded-md border bg-white px-2 py-1.5 text-left ${
          selectedHealth === health ? 'border-gray-800' : 'border-gray-200'
        }`}
      >
        <p className="truncate text-[11px] text-gray-500">
          {HEALTH_INFO[health].label}
        </p>
        <p className="text-lg font-semibold leading-6 text-gray-800">
          {summary[health] ?? 0}
        </p>
      </button>
    ))}
  </div>
)

export default CronJobSummary
